import React from 'react'
import styled from '@emotion/styled'
import {LINK_REPLACED_MESSAGE} from './contexts/payment-auth-context'

// Centered over everything. When the payment form is behind it (link replaced
// mid-session) the backdrop also blocks further clicks on the dead link.
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(23, 29, 55, 0.6);
`

const Box = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 520px;
  padding: 32px 36px;
  text-align: center;
  background: #fff4e5;
  border: 2px solid #f59e0b;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  color: #5f3b00;
  font-size: 16px;
  line-height: 1.5;
`

const Icon = styled.div`
  margin-bottom: 8px;
  font-size: 36px;
  line-height: 1;
`

const Title = styled.strong`
  display: block;
  margin-bottom: 8px;
  font-size: 20px;
`

const PageShell = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #171d37 0%, #4a5580 100%);
`

// Full-page variant for an old link opened on load: no token, so no payment form.
export function LinkReplacedPage() {
  return (
    <PageShell>
      <LinkReplacedBanner />
    </PageShell>
  )
}

export function LinkReplacedBanner() {
  return (
    <Overlay>
      <Box role="alert" data-testid="link-replaced-banner">
        <Icon aria-hidden="true">&#9888;</Icon>
        <Title>This payment link is no longer active</Title>
        {LINK_REPLACED_MESSAGE}
      </Box>
    </Overlay>
  )
}
